export default {
    lockBodyScroll: () => (document.getElementsByTagName('body')[0].style.overflow = 'hidden'),
    unlockBodyScroll: () => (document.getElementsByTagName('body')[0].style.overflow = 'auto')
};
